// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Ja8m","left":"InfoRow_left__2m9hV"};